import type { ComponentType } from "react";
import type { OrganId, OrganSvgProps } from "../types";
import { Blood } from "./Blood";
import { Breast } from "./Breast";
import { Cell } from "./Cell";
import { Constitutional } from "./Constitutional";
import { Digestive } from "./Digestive";
import { Ear } from "./Ear";
import { Endocrine } from "./Endocrine";
import { Eye } from "./Eye";
import { Growth } from "./Growth";
import { Head } from "./Head";
import { Heart } from "./Heart";
import { Immune } from "./Immune";
import { Integuments } from "./Integument";
import { Kidney } from "./Kidney";
import { Limbs } from "./Limbs";
import { Lung } from "./Lung";
import { Metabolism } from "./Metabolism";
import { Muscle } from "./Muscle";
import { Neoplasm } from "./Neoplasm";
import { Nervous } from "./Nervous";
import { Prenetal } from "./Prenatal";
import { ThoracicCavity } from "./ThoracicCavity";
import { Voice } from "./Voice";

/**
 * Map of organ IDs to their SVG components
 */
export const ORGAN_COMPONENTS: Record<OrganId, ComponentType<OrganSvgProps>> = {
  head: Head,
  eye: Eye,
  ear: Ear,
  thoracicCavity: ThoracicCavity,
  heart: Heart,
  lung: Lung,
  digestive: Digestive,
  kidney: Kidney,
  integument: Integuments,
  constitutional: Constitutional,
  limbs: Limbs,
  nervous: Nervous,
  breast: Breast,
  voice: Voice,
  metabolism: Metabolism,
  cell: Cell,
  endocrine: Endocrine,
  neoplasm: Neoplasm,
  immune: Immune,
  muscle: Muscle,
  growth: Growth,
  prenatal: Prenetal,
  blood: Blood,
};
